<template>
  <div>
    
    <NuxtLayout>
      <NuxtRouteAnnouncer />
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script lang="ts" setup>
import { fetchPage } from '@corporate/api'
import { GridOverlay } from '@gro-up/ui/components'
import { defineAsyncComponent, markRaw, onMounted, provide, ref } from 'vue'

const openAsyncPagePopupIds = ref<string[]>([])
provide('openAsyncPagePopupIds', openAsyncPagePopupIds)

// Shared popup context for components that can open a page in the AsyncPagePopup
// (e.g. EventCardSlider). Provided here so shared @gro-up/ui components stay
// decoupled from the corporate app's page fetcher and Page renderer.
provide('asyncPagePopup', {
  fetchPage,
  pageComponent: markRaw(defineAsyncComponent(() => import('@corporate/components/Page/Page.vue'))),
})

onMounted(async () => {
  const FloatingFocus = await import('@q42/floating-focus-a11y')
  new FloatingFocus.default()
})
</script>
